export enum SignalUserPlanUserStatusEnum {
    ACTIVE = 1,
    PAUSED = 2, // user paused plan to stop renewal
}
